module.exports = __webpack_public_path__ + "wxCircle.5a67bc66.png";